import api from './api'

const create = (token, modle = "addlogin", data) => {
  return api(token).post(modle, data)
}

const get = (token, modle = "imgdata", id) => {
  return api(token).get(`${modle}/${id}`)
}

const getAll = (token, modle = "imgdata") => {
  return api(token).get(modle)
}

const getDegree = (token, modle = "degree", stdId, testKindId) => {
  return api(token).get(`${modle}/${stdId}/${testKindId}`)
}

const getinfoImage = (token, secid, classid) => {
  return api(token).get(`getListInfoById/${secid}/${classid}`)
}

const getCourses = (token, modle = "course", courseId, gredId, termId, subjectId) => {

  return api(token).get(`${modle}/${courseId}/${gredId}/${termId}/${subjectId}`)
}

const getAllTopics = (token, modle = "alltopics", gredId, subjectId) => {

  return api(token).get(`${modle}/${gredId}/${subjectId}`)
}

const getTopics = (token, modle = "topics", gredId, termId, subejectId) => {

  return api(token).get(`${modle}/${gredId}/${termId}/${subejectId}`)
}

const getQuiz = (token, modle = "quiz", quizId, courseId, gredId, termId, subjectId) => {

  return api(token).get(`${modle}/${quizId}/${courseId}/${gredId}/${termId}/${subjectId}`)
}

const updateTopic = (token, modle = "topic", topicId, gredId, subejectId, termId, data) => {

  return api(token).put(`${modle}/${topicId}/${gredId}/${subejectId}/${termId}`, data)
}

const deleteTopic = (token, modle = "topic", topicId, gredId, subjectId, termId) => {

  return api(token).delete(`${modle}/${topicId}/${gredId}/${subjectId}/${termId}`)
}

const getCoursesByGrade = (token, modle = "getcoursebygrade", gredId, subjectId) => {

  return api(token).get(`${modle}/${gredId}/${subjectId}`)
}

const getTopicsTitles = (token, modle = "topicstitle", gredId, subjectId) => {

  return api(token).get(`${modle}/${gredId}/${subjectId}`)
}

const updateCourse = (token, modle = "course", courseId, gredId, subejectId, termId, data) => {

  return api(token).put(`${modle}/${courseId}/${gredId}/${subejectId}/${termId}`, data)
}

const updateCourseImg = (token, modle = "courseimg", courseImg, data) => {

  return api(token).put(`${modle}/${courseImg}`, data)
}

const deleteCourse = (token, modle = "course", topicId, courseId, gredId, subejectId, termId) => {

  return api(token).delete(`${modle}/${topicId}/${courseId}/${gredId}/${subejectId}/${termId}`)
}

const removeCourseImg = (token, imgUrl) => {
  return api(token).delete(`courseimage/${imgUrl}`)
}

const removeSubpartImg = (token, imgUrl) => {
  return api(token).delete(`subpartimage/${imgUrl}`)
}

const removeReviewImg = (token, imgUrl) => {

  return api(token).delete(`reviewimage/${imgUrl}`)
}

const removeQuestionImg = (token, imgUrl) => {

  return api(token).delete(`questionimage/${imgUrl}`)
}


const getCourseTitles = (token, modle = "coursestitle", gredId, subjectId) => {

  return api(token).get(`${modle}/${gredId}/${subjectId}`)
}

const getSubpartsByGrade = (token, modle = "getsubpartbygrade", gredId, subjectId) => {

  return api(token).get(`${modle}/${gredId}/${subjectId}`)
}

const updateSubpart = (token, modle = "subpart", subpartId, data) => {

  return api(token).put(`${modle}/${subpartId}`, data)
}


const deleteSubpart = (token, modle = "subpart", subpartId) => {

  return api(token).delete(`${modle}/${subpartId}`)
}

const updateSubpartImg = (token, modle = "subpartimg", subpartId, data) => {

  return api(token).put(`${modle}/${subpartId}`, data)
}


const getDtatByGrade = (token, modle, gredId, subjectId) => {

  return api(token).get(`${modle}/${gredId}/${subjectId}`)
}

const updateReviewImg = (token, modle = "reviewimg", reviewId, data) => {

  return api(token).put(`${modle}/${reviewId}`, data)
}

const delData = (token, modle, id) => {

  return api(token).delete(`${modle}/${id}`)
}

const updateData = (token, modle, id, data) => {

  return api(token).put(`${modle}/${id}`, data)
}

const delQuiz = (token, quizId, courseId, gradeId, subjectId, termId, modle = "quiz") => {

  return api(token).delete(`${modle}/${quizId}/${courseId}/${gradeId}/${subjectId}/${termId}`)
}

const updateQuiz = (token, quizId, couresId, gradeId, subjectId, termId, data, modle = "quiz") => {

  return api(token).put(`${modle}/${quizId}/${couresId}/${gradeId}/${subjectId}/${termId}`, data)
}

const getQuizId = (token, couresId, gradeId, subjectId, termId, modle = "getquizid") => {

  return api(token).get(`${modle}/${couresId}/${gradeId}/${subjectId}/${termId}`)
}

const getQuizQuesData = (token, quizId, courseId, gredId, subjectId, termId, modle = "getquestionsbyquiz") => {

  return api(token).get(`${modle}/${quizId}/${courseId}/${gredId}/${subjectId}/${termId}`)
}

const delQuestion = (token, questionId, courseId, quizId, gradeId, subjectId, termId, modle = "question") => {

  return api(token).delete(`${modle}/${questionId}/${courseId}/${quizId}/${gradeId}/${subjectId}/${termId}`)
}

const updateQueson = (token, questionId, courseId, quizId, gradeId, subjectId, termId, data, modle = "question") => {

  return api(token).put(`${modle}/${questionId}/${courseId}/${quizId}/${gradeId}/${subjectId}/${termId}`, data)
}

const getQuestionId = (token, courseId, quizId, gradeId, subjectId, termId, modle = "questionid") => {

  return api(token).get(`${modle}/${courseId}/${quizId}/${gradeId}/${subjectId}/${termId}`)
}

const getAnswer = (token, questionId, courseId, quizId, gradeId, subjectId, termId, modle = "answer") => {

  return api(token).get(`${modle}/${questionId}/${courseId}/${quizId}/${gradeId}/${subjectId}/${termId}`)
}

const getAssessment = (token, modle = "assessment", student_Id, term_id) => {
  return api(token).get(`${modle}/${student_Id}/${term_id}`)
}

const getStudentData = (token, modle = "getStudentData", gradeId) => {
  return api(token).get(`${modle}/${gradeId}`)
}

const getLessonVisits = (token, modle = "lesson-visits", studentId, subjectId, termId) => {
  return api(token).get(`${modle}/${studentId}/${subjectId}/${termId}`)
}

const deleteLessonVisits = (token, modle = "lesson-visits/reset", studentId, subjectId, termId) => {
  const data = { studentId, subjectId, termId }
  return api(token).delete(`${modle}`, { data: data })
}

const startQuizHistory = (token, data, modle = "start_quiz_history") => {
  return api(token).post(modle, data)
}

const updateQuizHistory = (token, historyId, data, modle = "update_quiz_history") => {
  return api(token).put(`${modle}/${historyId}`, data)
}

const finishQuizHistory = (token, historyId, modle = "finish_quiz_history") => {
  return api(token).put(`${modle}/${historyId}`)
}

const getLastQuizHistory = (token, stdCode, termId, subjectId, modle = "last_history") => {
  return api(token).get(`${modle}/${stdCode}/${termId}/${subjectId}`)
}

const getFinishedQuizzes = (token, stdCode, courseId, termId, subjectId, modle = "finished_quizzes") => {
  return api(token).get(`${modle}/${stdCode}/${courseId}/${termId}/${subjectId}`)
}

const getStudentProgress = (token, stdCode, gradeId, termId, subjectId, modle = "student_progress") => {
  return api(token).get(
    `${modle}/${stdCode}/${gradeId}/${termId}/${subjectId}`)
}

const getQuizAttempts = (token, stdCode, courseId, termId, subjectId, modle = "quiz_attempts") => {
  return api(token).get(`${modle}/${stdCode}/${courseId}/${termId}/${subjectId}`)
}

const getCurrentYear = (token, modle = "current") => {
  return api(token).get(modle)
}

const getQuizTop10ByTopic = (token, gradeId, subjectId, termId, topicId, modle = "quiz-top10/topic") => {
  return api(token).get(`${modle}/${gradeId}/${subjectId}/${termId}/${topicId}`)
}

const getQuizTop10ByCourse = (token, gradeId, subjectId, termId, courseId, modle = "quiz-top10/course") => {
  return api(token).get(`${modle}/${gradeId}/${subjectId}/${termId}/${courseId}`)
}

const getQuizTop10ByCourses = (token, gradeId, subjectId, termId, courseIds, modle = "quiz-top10/courses") => {
  return api(token).get(`${modle}/${gradeId}/${subjectId}/${termId}/${courseIds}`)
}

const getOverallTop10 = (token, data, modle = "overall-top10") => {
  return api(token).post(modle, data)
}

const CurdTokenervice = {
  create,
  get,
  getAll,
  getDegree,
  getinfoImage,
  getCourses,
  getAllTopics,
  getTopics,
  getQuiz,
  updateTopic,
  deleteTopic,
  getCoursesByGrade,
  getTopicsTitles,
  updateCourse,
  deleteCourse,
  removeCourseImg,
  removeSubpartImg,
  removeReviewImg,
  removeQuestionImg,
  updateCourseImg,
  getCourseTitles,
  getSubpartsByGrade,
  updateSubpart,
  deleteSubpart,
  updateSubpartImg,
  updateReviewImg,
  getDtatByGrade,
  delData,
  updateData,
  delQuiz,
  updateQuiz,
  getQuizId,
  getQuizQuesData,
  delQuestion,
  updateQueson,
  getQuestionId,
  getAnswer,
  getAssessment,
  getStudentData,
  getLessonVisits,
  deleteLessonVisits,
  startQuizHistory,
  updateQuizHistory,
  finishQuizHistory,
  getLastQuizHistory,
  getFinishedQuizzes,
  getStudentProgress,
  getQuizAttempts,
   getQuizTop10ByTopic,
  getQuizTop10ByCourse,
  getQuizTop10ByCourses,
  getCurrentYear,
  getOverallTop10,
}
export default CurdTokenervice
